/**
 * Mini sticker upsell panel, attached to the quick-add popup.
 *
 * After a shopper adds a product with a linked "MINI PACK" option to the cart from the quick-add
 * modal, this script intercepts the modal's default auto-close behavior (just once, for the main
 * product's own add-to-cart) and instead slides open a side panel — attached to and extending the
 * popup itself — offering 1x1 mini-sticker packs of the same design. The panel has its own
 * independent Add to Cart action, priced separately from the main product.
 *
 * While the panel is open, the quantity selector, the main product's own Add to Cart button, and
 * the "back to full product page" title link inside #quick-add-modal-content are smoothly
 * collapsed out of the way so the mini sticker panel + its own Add Mini Stickers button are the
 * sole focus. They reappear once the panel closes.
 */
(function () {
  var MAX_POLL_ATTEMPTS = 60;
  var POLL_MS = 50;
  var CHROME_TRANSITION_MS = 380;

  function init() {
    var dialogEl = document.getElementById('quick-add-dialog');
    var panel = document.getElementById('quick-add-upsell-panel');
    if (!dialogEl || !panel) return;

    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (typeof dialogEl.handleCartUpdate === 'function') {
        clearInterval(poll);
        patch(dialogEl, panel);
      } else if (attempts > MAX_POLL_ATTEMPTS) {
        clearInterval(poll);
      }
    }, POLL_MS);
  }

  function patch(dialogEl, panel) {
    if (dialogEl.dataset.miniUpsellPatched === 'true') return;
    dialogEl.dataset.miniUpsellPatched = 'true';

    var select = panel.querySelector('[data-mini-upsell-select]');
    var image = panel.querySelector('[data-mini-upsell-image]');
    var confirmEl = panel.querySelector('[data-mini-upsell-confirm]');
    var addBtn = panel.querySelector('[data-mini-upsell-add]');
    var closeEls = panel.querySelectorAll('[data-mini-drawer-close]');

    function readMiniData() {
      var dataEl = document.querySelector('#quick-add-modal-content [data-mini-sticker-upsell]');
      if (!dataEl) return null;
      var variantEls = Array.prototype.slice.call(dataEl.querySelectorAll('[data-mini-variant]'));
      if (!variantEls.length) return null;
      return {
        title: dataEl.getAttribute('data-product-title') || '',
        image: dataEl.getAttribute('data-product-image') || '',
        variants: variantEls.map(function (el) {
          return {
            id: el.getAttribute('data-variant-id'),
            label: el.getAttribute('data-label'),
            price: el.getAttribute('data-price'),
          };
        }),
      };
    }

    function populatePanel(data) {
      if (image && data.image) {
        image.src = data.image;
        image.alt = data.title;
      }
      if (select) {
        select.innerHTML = data.variants
          .map(function (v) {
            return '<option value="' + v.id + '">' + v.label + ' – ' + v.price + '</option>';
          })
          .join('');
      }
      if (confirmEl) confirmEl.hidden = true;
      if (addBtn) {
        addBtn.hidden = false;
        addBtn.disabled = false;
      }
      panel.hidden = false;
    }

    /**
     * Chrome elements (inside the fetched/morphed #quick-add-modal-content) that get
     * smoothly collapsed while the mini sticker panel is focused. ".view-product-title"
     * covers the desktop "back to full product page" title link; on mobile quick-add.js
     * (core theme) replaces that with a ".product-header" wrapper around an equivalent
     * title link, so we fall back to that when .view-product-title isn't present.
     */
    function getChromeEls() {
      var content = document.getElementById('quick-add-modal-content');
      if (!content) return [];
      var qty = content.querySelector('.quantity-selector-wrapper');
      var atc = content.querySelector('.add-to-cart-button');
      var backLink = content.querySelector('.view-product-title') || content.querySelector('.product-header');
      return [qty, atc, backLink].filter(Boolean);
    }

    function setChromeCollapsed(collapsed) {
      getChromeEls().forEach(function (el) {
        el.classList.add('quick-add-chrome');
        el.classList.toggle('quick-add-chrome--collapsed', collapsed);
        if (collapsed) {
          el.setAttribute('inert', '');
        } else {
          el.removeAttribute('inert');
        }
      });
    }

    function scrollUpsellPanelIntoView() {
      // Wait for the chrome-collapse and width/max-height expand transitions (0.35s) to
      // finish so the scroll target reflects the panel's final, fully-settled position.
      // block: 'end' (rather than 'center') brings the bottom of the panel — where the
      // set-size dropdown and Add Mini Stickers button live — into view, with a little
      // breathing room from scroll-margin-bottom on .quick-add-upsell-panel.
      setTimeout(function () {
        panel.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }, CHROME_TRANSITION_MS);
    }

    function openPanel() {
      var data = readMiniData();
      if (!data) return false;
      populatePanel(data);
      var modal = dialogEl.querySelector('.quick-add-modal');
      setChromeCollapsed(true);
      requestAnimationFrame(function () {
        if (modal) modal.classList.add('quick-add-modal--upsell-open');
        panel.classList.add('is-open');
      });
      scrollUpsellPanelIntoView();
      return true;
    }

    function closePanel() {
      var modal = dialogEl.querySelector('.quick-add-modal');
      if (modal) modal.classList.remove('quick-add-modal--upsell-open');
      panel.classList.remove('is-open');
      setChromeCollapsed(false);
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', closePanel);
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = select && select.value;
        if (!variantId) return;

        addBtn.disabled = true;

        // Request the same sections the native product form requests on add, so this
        // custom flow feeds the theme's real cart-icon/cart-drawer refresh mechanism
        // instead of leaving them stale until a later live re-fetch catches up.
        var sectionIds = Array.prototype.map
          .call(document.querySelectorAll('cart-items-component'), function (el) {
            return el.dataset.sectionId;
          })
          .filter(Boolean);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: sectionIds.join(','),
          }),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (json) {
            if (json.status) throw new Error(json.message || 'Could not add mini stickers');

            if (confirmEl) confirmEl.hidden = false;
            addBtn.hidden = true;

            fetch('/cart.js')
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                document.dispatchEvent(
                  new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: cart,
                      sourceId: 'mini-sticker-upsell-add',
                      data: { source: 'mini-sticker-upsell', itemCount: cart.item_count, sections: json.sections },
                    },
                  })
                );
              })
              .catch(function () {});

            setTimeout(function () {
              closePanel();
              if (typeof dialogEl.closeDialog === 'function') dialogEl.closeDialog();
            }, 1400);
          })
          .catch(function (err) {
            console.error(err);
            addBtn.disabled = false;
          });
      });
    }

    dialogEl.addEventListener('dialog:open', function () {
      closePanel();
      panel.hidden = true;
    });

    var originalHandleCartUpdate = dialogEl.handleCartUpdate;
    dialogEl.removeEventListener('cart:update', originalHandleCartUpdate);

    dialogEl.handleCartUpdate = function (event) {
      var detailData = (event.detail && event.detail.data) || {};
      var isMainProductAdd = detailData.source === 'product-form-component' && !detailData.didError;

      if (isMainProductAdd) {
        if (openPanel()) return;
      }

      originalHandleCartUpdate(event);
    };

    dialogEl.addEventListener('cart:update', dialogEl.handleCartUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
